import * as React from 'react'
import Svg, { Path } from 'react-native-svg'

type GrowIconProps = {
  width?: number
  height?: number
}

const GrowIcon = ({ width, height }: GrowIconProps) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 21 21" fill="none">
      <Path
        fill="#7D66FF"
        // eslint-disable-next-line max-len
        d="M4.146 17.449a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.594v-.833q0-.354.24-.593a.8.8 0 0 1 .593-.24q.354 0 .594.24a.8.8 0 0 1 .24.593v.833q0 .355-.24.595a.8.8 0 0 1-.594.239m3.334 0a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594v-4.583q0-.354.24-.593a.8.8 0 0 1 .594-.24q.353 0 .594.24a.8.8 0 0 1 .239.593v4.583q0 .355-.24.595a.8.8 0 0 1-.593.239m3.333 0a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.594V13.7q0-.354.24-.594a.8.8 0 0 1 .593-.24q.354 0 .594.24a.8.8 0 0 1 .24.594v2.916q0 .355-.24.595a.8.8 0 0 1-.594.239m3.333 0a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.594V12.45q0-.354.24-.594a.8.8 0 0 1 .593-.24q.354 0 .595.24a.8.8 0 0 1 .239.594v4.166q0 .355-.24.595a.8.8 0 0 1-.594.239m3.334 0a.8.8 0 0 1-.594-.24.8.8 0 0 1-.24-.594v-7.5q0-.354.24-.593a.8.8 0 0 1 .594-.24q.352 0 .594.24a.8.8 0 0 1 .239.593v7.5q0 .355-.24.595a.8.8 0 0 1-.593.239m-5-7.521q-.334 0-.636-.125a1.9 1.9 0 0 1-.552-.354L9.146 7.303 4.73 11.72a.78.78 0 0 1-.594.24.85.85 0 0 1-.594-.261.8.8 0 0 1-.218-.594.82.82 0 0 1 .239-.573l4.396-4.396q.249-.25.552-.364t.635-.115q.333 0 .646.115.314.116.542.364l2.146 2.146 4.416-4.417a.78.78 0 0 1 .595-.24q.344.01.593.261a.81.81 0 0 1 .219.594.8.8 0 0 1-.24.573l-4.396 4.396q-.23.228-.541.354a1.7 1.7 0 0 1-.646.125"
      />
    </Svg>
  )
}

GrowIcon.defaultProps = {
  width: 21,
  height: 21
}

export default GrowIcon
